import styled from 'styled-components';

import { rem } from 'approot/shared/style';
import { purple1, purple7, purple9 } from 'approot/shared/styles/colours.style';
import {
  spacing16,
  spacing24,
  spacing8,
} from 'approot/shared/styles/spacing.style';
import { flexCentreAlignCss } from 'approot/shared/styles/flex.style';
import {
  boxShadowBlack12,
  standardBorderRadius,
} from 'approot/shared/styles/borders.style';
import { font16 } from 'approot/shared/styles/typography.style';
import { SecondaryButtonIcon } from 'approot/shared/styles/buttons/secondary-button.style';
import { TextStyled } from 'approot/shared/styles/typography/text.style';

export const MultipleChoiceStudentHint = styled.div`
  ${flexCentreAlignCss}
  ${font16}
  
  position: absolute;
  bottom: -${rem(spacing24)};
  left: 0;
  right: 0;
  z-index: 2;

  & > div {
    ${standardBorderRadius}
    ${boxShadowBlack12}
    background-color: ${purple1};
    color: ${purple9};
    padding: ${rem(spacing8)} ${rem(spacing8)} ${rem(spacing8)}
      ${rem(spacing16)};
  }

  svg {
    path {
      stroke: ${purple7};
    }
  }

  ${TextStyled} {
    color: ${purple7};
  }

  ${SecondaryButtonIcon} {
    background-color: transparent;

    &:hover {
      background-color: rgba(0, 0, 0, 0.1);
    }
  }
`;
